import { useEffect } from 'react';

/**
 * Adds the `visible` class to elements matching selector when they enter the viewport.
 * Usage: add `data-reveal` + `fade-in-on-scroll` class to any element.
 */
export const useRevealOnScroll = (selector = '[data-reveal]') => {
  useEffect(() => {
    const elements = Array.from(document.querySelectorAll(selector));
    if (elements.length === 0) return;

    // Fallback: if IntersectionObserver isn't available, reveal everything.
    if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
      elements.forEach((el) => el.classList.add('visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.14,
        rootMargin: '0px 0px -10% 0px',
      }
    );

    elements.forEach((el) => observer.observe(el));

    return () => {
      observer.disconnect();
    };
  }, [selector]);
};
